var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Combined Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8808717,2.67134444 L13.3116344,6.10210712 L4.50744002,14.90554 C4.46314999,14.94983 4.4076923,14.9816833 4.34665078,14.996912 L4.34665078,14.996912 L0.430093936,15.9728151 C0.402428558,15.9797949 0.374001731,15.9832213 0.346209424,15.9832213 C0.255472,15.9832213 0.166765063,15.9471802 0.101662562,15.8820777 C0.0156206647,15.7960358 -0.0190245548,15.6706531 0.0101637211,15.552758 L0.0101637211,15.552758 L0.985939924,11.6362011 C1.00116858,11.575921 1.03314876,11.5198288 1.07743876,11.4754119 L1.07743876,11.4754119 L9.8808717,2.67134444 Z M12.0619961,0.490981452 C12.7161939,-0.163343186 13.8577086,-0.163977705 14.5126678,0.490981452 L14.5126678,0.490981452 L15.4926319,1.47094556 C15.8197942,1.79810786 16,2.23339366 16,2.69634484 C16,3.15929602 15.8197942,3.59458179 15.4926319,3.9216172 L15.4926319,3.9216172 L14.292233,5.12201611 L10.8615972,1.69138037 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.92822d3b.svg";
export { ForwardRef as ReactComponent };